var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.renderId,
      staticClass: "gallery-image-card",
      class: { opac: !_vm.current },
    },
    [
      _vm.removeCardEnabled
        ? _c(
            "div",
            { staticClass: "control-toolbar" },
            [
              _c(
                "md-button",
                { staticClass: "md-icon-button md-mini" },
                [_c("md-icon", [_vm._v("swap_horiz")])],
                1
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-icon-button md-mini",
                  on: { click: _vm.removeCard },
                },
                [_c("md-icon", [_vm._v("delete")])],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _c(
          "section",
          { staticClass: "image", class: { empty: !_vm.card.imageUrl } },
          [
            !_vm.card.imageUrl && !_vm.selectedImage
              ? _c(
                  "div",
                  {
                    staticClass: "placeholder",
                    on: { click: _vm.openSelectImage },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" photo_camera "),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.dragAndDropBrowse"))),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "position-relative",
                    on: {
                      mouseover: function ($event) {
                        _vm.hovered = true
                      },
                      mouseleave: function ($event) {
                        _vm.hovered = false
                      },
                    },
                  },
                  [
                    _vm.card.imageUrl && !_vm.uploading
                      ? _c("img", {
                          staticClass: "preview",
                          attrs: { src: _vm.card.imageUrl },
                        })
                      : _vm.selectedImageSrc
                      ? _c("img", {
                          staticClass: "preview",
                          attrs: { src: _vm.selectedImageSrc },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.uploading
                      ? _c(
                          "div",
                          { staticClass: "uploading-banner" },
                          [
                            _c("a-progress", {
                              attrs: {
                                type: "circle",
                                "stroke-color": {
                                  "0%": "#108ee9",
                                  "100%": "#87d068",
                                },
                                percent: _vm.uploadProgress,
                                size: "small",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.imageUploading")) + "."
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.card.imageUrl && !_vm.uploading && _vm.hovered
                      ? _c(
                          "div",
                          {
                            staticClass: "update-banner",
                            on: { click: _vm.openSelectImage },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v(" photo_camera "),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("chatbotv2.clickToChooseNewImage")
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("chatbotv2.or")) +
                                  "\n                        "
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "remove",
                                  on: { click: _vm.removeImage },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("chatbotv2.removeTheExistingOne")
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "title" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.typeCardTitle"),
                "show-attributes":
                  _vm.showAttributes === undefined ||
                  _vm.showAttributes === true,
                "show-emoji":
                  _vm.showEmoji === undefined || _vm.showEmoji === true,
                "show-emoji-picker": _vm.showEmojiPicker,
                "max-character-count": 80,
                "whatsapp-mode": _vm.whatsappMode,
                "allowed-attributes": _vm.allowedAttributes,
                "preview-mode": _vm.previewMode,
              },
              model: {
                value: _vm.card.title,
                callback: function ($$v) {
                  _vm.$set(_vm.card, "title", $$v)
                },
                expression: "card.title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "description" },
          [
            _c("TiptapEditor", {
              attrs: {
                placeholder: _vm.$t("chatbotv2.typeCardDescription"),
                "show-attributes":
                  _vm.showAttributes === undefined ||
                  _vm.showAttributes === true,
                "show-emoji":
                  _vm.showEmoji === undefined || _vm.showEmoji === _vm.tru,
                "show-emoji-picker": _vm.showEmojiPicker,
                "whatsapp-mode": _vm.whatsappMode,
                "allowed-attributes": _vm.allowedAttributes,
                "preview-mode": _vm.previewMode,
              },
              model: {
                value: _vm.card.description,
                callback: function ($$v) {
                  _vm.$set(_vm.card, "description", $$v)
                },
                expression: "card.description",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "buttons" },
          [
            _vm._l(_vm.card.buttons, function (button, i) {
              return _c(
                "div",
                { key: button.id, staticClass: "card-button" },
                [
                  _c(
                    "a-popover",
                    {
                      key: button.id,
                      attrs: {
                        visible: _vm.editingButtonPopupVisibleMap[button.id],
                        placement: "left",
                        trigger: "click",
                        overlayClassName: "no-padding",
                      },
                      on: {
                        visibleChange: function (e) {
                          return _vm.visibleChange(button.id, e)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _c("ActionButtonUpdater", {
                            attrs: {
                              "on-completed": function () {
                                _vm.editingButtonPopupVisibleMap[
                                  button.id
                                ] = false
                              },
                              "popup-visible":
                                _vm.editingButtonPopupVisibleMap[button.id],
                              flattedDiagram: _vm.flattedDiagram,
                              "whatsapp-mode": _vm.whatsappMode,
                              "allowed-attributes": _vm.allowedAttributes,
                            },
                            model: {
                              value: _vm.card.buttons[i],
                              callback: function ($$v) {
                                _vm.$set(_vm.card.buttons, i, $$v)
                              },
                              expression: "card.buttons[i]",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center w-100 h-100",
                          on: {
                            click: function ($event) {
                              return _vm.openEditButtonPopup(button.id)
                            },
                          },
                        },
                        [_vm._v(_vm._s(button.title))]
                      ),
                      _vm._v(" "),
                      _vm.card.buttons.length > 1
                        ? _c(
                            "div",
                            { staticClass: "button-controls" },
                            [
                              _c(
                                "md-button",
                                {
                                  staticClass: "md-icon-button md-mini",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeButton(button.id)
                                    },
                                  },
                                },
                                [_c("md-icon", [_vm._v("delete_outline")])],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            !_vm.previewMode
              ? _c("div", { staticClass: "buttons-add" }, [
                  _c("div", { staticClass: "buttons-add-line" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttons-add-wrapper" }, [
                    _c(
                      "div",
                      {
                        staticClass: "buttons-add-plus",
                        on: { click: _vm.addButton },
                      },
                      [
                        _c("span", { staticClass: "material-icons" }, [
                          _vm._v(" add "),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "buttons-add-text" }, [
                      _vm._v(_vm._s(_vm.$t("chatbotv2.addButton"))),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.showAddCard && !_vm.previewMode
        ? _c("div", { staticClass: "cards-add-main" }, [
            _c("div", { staticClass: "cards-add" }, [
              _c("div", { staticClass: "cards-add-line" }),
              _vm._v(" "),
              _c("div", { staticClass: "cards-add-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "cards-add-plus", on: { click: _vm.addCard } },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" add "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "cards-add-text" }, [
                  _vm._v(_vm._s(_vm.$t("chatbotv2.addCard"))),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }